import z from "zod";

/**
 * CreatePesquisaSatisfacaoClienteSchema
 */

export const CreatePesquisaSatisfacaoClienteSchema = z.object({
  pesquisaSatisfacao: z.array(z.number(), { required_error: "Selecione ao menos um item." })
    .nonempty("Selecione ao menos um item."),
});

/**
 * CreatePesquisaSatisfacaoClienteForm
 */

export type CreatePesquisaSatisfacaoClienteForm = z.infer<typeof CreatePesquisaSatisfacaoClienteSchema>;